import { useEffect, useState } from 'react'
import { useParams, useSearchParams, Link, useLocation } from 'react-router-dom'
import dompurify from 'dompurify'

import Spinner from 'react-bootstrap/Spinner'

import Menu from '../../components/MenuA2A2'
import Botao from '../../components/Botao'
import CardEmpresaA2A2 from '../../components/CardEmpresaA2A2'
import TituloNegrito from '../../components/TituloNegrito'
import ProdutosCertificados from '../../components/ProdutosCertificadosA2A2'
import PontosDeVenda from '../../components/PontosDeVenda'
import Divisor from '../../components/Divisor'
import Imagens from '../../components/Imagens'
import Noticias from '../../components/Noticias'
import Videos from '../../components/Videos';
import Contatos from '../../components/Contatos';

import constantes from '../../helpers/constanteHelper'

import sheetsService from '../../services/sheetsServiceA2A2'
import DetalhesCertificacaoA2A2 from '../../components/DetalhesCertificacaoA2A2'

function DadosEmpresaA2A2() {
    const [width, setWidth] = useState(window.innerWidth)
    const [empresa, setEmpresa] = useState({})
    const sanitizer = dompurify.sanitize

    const { slug } = useParams();
    const [searchParams, setSearchParams] = useSearchParams()

    const location = useLocation()

    // Controle de carregamento da tela
    const [telaCarregada, setTelaCarregada] = useState(false)

    // Controle de idioma
    const [idioma, setIdioma] = useState(location?.state?.idioma ?? 'pt')

    function observarMudancaWidth() {
        setWidth(window.innerWidth)
    }

    function separarItensDesseIdioma(tipoItem) {
        return empresa[tipoItem]?.filter((item) => {
            if (idioma === 'pt') {
                return item['Português']?.toUpperCase() === 'X'
            } else if (idioma === 'en') {
                return item['Inglês']?.toUpperCase() === 'X'
            } else if (idioma === 'es') {
                return item['Espanhol']?.toUpperCase() === 'X'
            } else if (idioma === 'fr') {
                return item['Francês']?.toUpperCase() === 'X'
            }
        })
    }

    useEffect(() => {
        sheetsService.buscarDadosEmpresas().then((empresasBuscadas) => {
            for (let i = 0; i < empresasBuscadas.length; i++) {

                if (empresasBuscadas[i]['Slug (Url)'] === slug) {
                    setEmpresa(empresasBuscadas[i])
                    setTelaCarregada(true)
                }
            }

            const veioDoBotaoPontosDeVenda = searchParams.get('pontos')

            if (veioDoBotaoPontosDeVenda === 'true') {
                // Se vier com parâmetro de pontos de venda, scrollar para o ponto de venda
                setTimeout(() => {
                    document.getElementById('pontos')?.scrollIntoView()
                }, 200)
            } else {
                // Se não, usar o scroll padrão que é para o topo da tela para melhor visualização no mobile ou em resoluções menores
                window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
            }
        })

        window.addEventListener('resize', observarMudancaWidth);

        return () => {
            window.removeEventListener('resize', observarMudancaWidth);
        }

    }, []);

    const resolucaoMobile = width <= constantes.RESPONSIVIDADE.LARGURA_MOBILE

    const regraExibicaoMenu = searchParams.get('menu')

    return (
        <>
            {telaCarregada ? <div style={{ padding: resolucaoMobile ? '0px 5px 0px 5px' : '0px', minHeight: '100vh', background: constantes.CORES.AZUL_A2A2 }} className='text-center d-flex flex-column align-items-center'>
                {regraExibicaoMenu === 'false' ? <></> : <Menu opcaoSelecionada={'marcas'} />}

                <div className='mt-5'></div>
                <div className='mt-5'></div>

                <CardEmpresaA2A2 resolucaoMobile={resolucaoMobile} empresa={empresa} desativarLink={regraExibicaoMenu === 'false'} />

                <TituloNegrito texto={empresa['Empresa']} />

                <div dangerouslySetInnerHTML={{ __html: sanitizer(empresa['Descrição da empresa']) }} className='mt-5 mb-5' style={{ width: resolucaoMobile ? '90vw' : '70vw', color: constantes.CORES.BRANCO_PADRAO, fontSize: resolucaoMobile ? '16px' : '20px', whiteSpace: 'pre-line', textAlign: resolucaoMobile ? 'justify' : 'center', }}></div>

                {empresa['Site da empresa'] ? <Link className='mb-5' style={{ textDecoration: 'none' }} to={empresa['Site da empresa']} target='_blank' rel='noopener noreferrer'>
                    <Botao cor={constantes.CORES.BRANCO_PADRAO} corTexto={constantes.CORES.AZUL_A2A2} largura={300} icone={'site'} texto={'Acessar site da empresa'} />
                </Link> : <></>}

                {empresa['Contatos'] && separarItensDesseIdioma('Contatos').length > 0 ? <>
                    <Divisor />
                    <Contatos contatos={separarItensDesseIdioma('Contatos')} resolucaoMobile={resolucaoMobile} idioma={idioma} /></> :
                    <></>}

                {regraExibicaoMenu ? <DetalhesCertificacaoA2A2 resolucaoMobile={resolucaoMobile} /> : <></>}

                <Divisor />

                {empresa['Produtos'] ? <ProdutosCertificados resolucaoMobile={resolucaoMobile} produtos={empresa['Produtos']} exibirMenu={searchParams.get('menu') === 'false' ? false : true} /> : <></>}

                {empresa['Vídeos'] ? <><Divisor />
                    <Videos item={empresa} resolucaoMobile={resolucaoMobile} idioma={idioma} /></>
                    : <></>}

                {empresa['Imagens'] && separarItensDesseIdioma('Imagens').length > 0 ? <>
                    <Divisor />
                    <Imagens imagens={separarItensDesseIdioma('Imagens')} resolucaoMobile={resolucaoMobile} idioma={idioma} /></> :
                    <></>
                }

                {empresa['Notícias'] && separarItensDesseIdioma('Notícias').length > 0 ? <>
                    <Divisor />
                    <Noticias noticias={separarItensDesseIdioma('Notícias')} resolucaoMobile={resolucaoMobile} idioma={idioma} /></> :
                    <></>
                }

                <Divisor />

                <div id='pontos'>
                    <PontosDeVenda pontosDeVenda={empresa['Pontos de venda']} resolucaoMobile={resolucaoMobile} exibirMenu={searchParams.get('menu') === 'false' ? false : true} />
                </div>

                <div className='mt-5'></div>

            </div> : <div style={{ minHeight: '100vh', background: constantes.CORES.AZUL_A2A2 }} className='d-flex flex-column align-items-center'>
                <div style={{ height: '100vh', gap: '20px' }} className='mt-5 d-flex flex-column align-items-center justify-content-center text-center'>
                    <Spinner style={{ height: '60px', width: '60px' }} variant='light' />
                    <span className='mt-3' style={{ fontSize: '20px', color: constantes.CORES.BRANCO_PADRAO, paddingLeft: '20px', paddingRight: '20px' }}>Carregando dados...<br />Por gentileza, aguarde alguns instantes.</span>
                </div>
            </div>}
        </>
    );
}

export default DadosEmpresaA2A2
